/**
 * Capitalizes the first letter of a string
 */
export default function Capitalize(str: string | null): string {
    if (!str) {
        return "";
    }

    const capitalizedFirst = str[0]?.toUpperCase() || "";
    const rest = str.slice(1);

    return capitalizedFirst + rest;
}
